// Angular Imports
// =========================================================
import { Component } from '@angular/core'
// AG Grid Imports
// =========================================================
import { type ICellRendererAngularComp } from 'ag-grid-angular'
import { AgCheckboxSelector, AgPopupComponent, RefPlaceholder } from 'ag-grid-community'

@Component({
  standalone: false,
  selector: 'checkbox-selection-header-renderer',
  templateUrl: './checkbox-selection-header-renderer.component.html',
  styleUrls: ['./checkbox-selection-header-renderer.component.scss']
})
export class CheckboxSelectionHeaderRenderer extends AgPopupComponent<any, any, any, any, any, any> {
  eCheckbox: any
  params: any

  constructor () {
    super(
            /* html */
            `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" data-ref="eCheckbox"></ag-checkbox>
            </div>`,
            [AgCheckboxSelector]
    )
    this.eCheckbox = RefPlaceholder
  }

  init (params: any) {
    this.params = params
    const isSelected = this.params.context.getHeaderCheckboxValue()
    const eCheckbox = this.eCheckbox
    eCheckbox.setValue(isSelected)
    const inputEl = eCheckbox.getInputElement()
    inputEl.setAttribute('tabindex', '-1')
    this.setAriaLabel(isSelected);
    (this as any).addManagedListeners(eCheckbox, {
      fieldValueChanged: (event: any) => {
        this.setAriaLabel(event.selected)
        if (this.params.context.changeHeaderCheckboxValue) {
          this.params.context.changeHeaderCheckboxValue(event.selected)
        }
      }
    })
  }

  getValue () {
    return this.eCheckbox.getValue()
  }

  focusIn () {
    this.eCheckbox.getFocusableElement().focus()
  }

  afterGuiAttached () {
    if (this.params.cellStartedEdit) {
      this.focusIn()
    }
  }

  isPopup () {
    return false
  }

  setAriaLabel (isSelected: any) {
    const translate = (this as any).getLocaleTextFunc()
    const stateName = this._getAriaCheckboxStateName(translate, isSelected)
    const ariaLabel = translate('ariaToggleCellValue', 'Press SPACE to toggle cell value')
    this.eCheckbox.setInputAriaLabel(`${ariaLabel} (${stateName})`)
  }

  _getAriaCheckboxStateName (translate: any, state: any) {
    console.log('translating state for aria label', state)
    return state === true
      ? translate('ariaChecked', 'checked')
      : state === false
        ? translate('ariaUnchecked', 'unchecked')
        : translate('ariaIndeterminate', 'indeterminate')
  }
}
